<template>
  <div>
    <div class="column is-12" :class="{'is-paddingless-bottom': p.users && p.users.length}">
      <p class="label is-padding-bottom-small">
        Membre(s) du pôle <span class="tag has-text-weight-normal is-xsmall is-primary is-margin-left-xsmall">{{p.users.length}}</span>
      </p>
      <div class="column is-12 is-paddingless columns is-multiline"
            v-if="p.users && !p.users.length">
        <div class="notification is-warning is-radius-large is-padding-small">
          <p class="is-margin-right">
            <i class="fal fa-comment-alt-exclamation fa-lg is-inline-block is-vcentered is-margin-right-xsmall"></i>
            <span>Aucun membre dans le pôle<br></span>
          </p>
        </div>
      </div>
      <div class="columns is-vcentered is-gapless is-margin-top-small is-border is-padding-small">
        <div class="column">
          <div class="bloc-add is-uppercase" @click.prevent.stop="openAddNewMember">
            <span class="picto">
              <span class="is-border"><i class="fal fa-user-plus"></i></span>
            </span>
            <span>Ajouter un Membre</span>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12 is-paddingless-top" v-if="p.users && p.users.length">
      <transition-group enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
        <div class="columns is-vcentered is-gapless is-margin-top-small is-border is-padding-small"
              v-for="(u, i) in p.users" :key="u.user">
          <div class="column columns is-gapless">
            <div class="column is-10 is-vcentered columns">
              <avatar :item="u" :i="i"></avatar>
              <div class="is-margin-left-small">
                <div class="title is-4">
                  <router-link :to="{name: 'UserVue', params: {id: u.user}}"><b>{{u.first_name}} {{u.last_name}}</b></router-link>
                  <span class="has-text-grey is-size-5"> / {{u.email}}</span>
                </div>
                <div class="subtitle">{{u.profil_type|profilTypeLabel}}</div>
              </div>
            </div>
            <div class="column is-1 has-text-right actions is-margin-right-xsmall tooltip is-tooltip-top is-tooltip-primary" data-tooltip="Inclure les membres du groupe">
              <button class="button is-circle" @click="addGroup(u)" v-if="u.profil_type === 'manager' || u.profil_type === 'manager_ext'">
                <i class="fal fa-user-plus"></i>
              </button>
            </div>
            <div class="column is-1 has-text-right actions is-padding-right-xsmall">
              <button class="button is-circle" @click="deleteUser(u, i)">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
  import { DefaultValues } from '@/mixins'
  import { mapState } from 'vuex'

  export default {
    name: 'MembersPanel',
    mixins: [DefaultValues],
    props: {
      pole: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState(['quickview']),
      p () {
        return this.pole
      },
      polePk () {
        return this.pole.pk
      }
    },
    watch: {
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'SELLER_SELECTION') {
            let users = results.entities.map(x => x.pk)
            this.addUsers(users)
          }
        }
      }
    },
    methods: {
      openAddNewMember () {
        let userPk = this.p.users.map(x => x.user)
        let params = {
          excludes: userPk,
          mode: 'append'
        }
        this.$store.commit('setQuickview', {mode: 'SELLER_SELECTION', params})
      },
      addUsers (users) {
        this.$api.poleService.postUsersPole(this.polePk, {users}).then(r => {
          r.data.forEach(el => {
            this.p.users.unshift(el)
          })
          this.$notify({
            type: 'is-success',
            text: 'Utilisateur ajouté au pôle'
          })
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de l\'ajout de l\'utilisateur'
          })
        })
      },
      deleteUser (user, idx) {
        this.$api.poleService.deleteUsersPole(this.polePk, user.user).then(r => {
          user.pk = user.user
          this.p.users.splice(idx, 1)
          this.$notify({
            type: 'is-success',
            text: 'Utilisateur supprimé du pôle'
          })
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la suppression de l\'utilisateur'
          })
        })
      },
      async addGroup (user) {
        let manager = null
        let request = await this.$api.userService.getOne(user.user)
        manager = request.data
        let allUsers = manager.sellers.map(x => x.user).concat([manager.pk])
        let okUser = allUsers.filter(el => {
          if (!this.p.users.map(e => e.user).includes(el)) return el
        })
        if (!okUser.length) {
          return this.$notify({
            type: 'is-info',
            text: 'Pas d\'utilisateur à ajouter'
          })
        }
        this.$api.poleService.postUsersPole(this.polePk, {users: okUser}).then(r => {
          r.data.forEach(el => {
            this.p.users.unshift(el)
          })
          this.$notify({
            type: 'is-success',
            text: 'Utilisateur ajouté au pôle'
          })
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de l\'ajout de l\'utilisateur'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pole/PolePanel/MembersPanel.vue